<template>
    <div>
        <h5>Expedientes encontrados</h5>
        <hr />
        <div v-bind:class="[!EsConsulta? 'altoDeTablaFijo':'','table-responsive']">
            <!-- class="table-responsive" -->
        <table v-if="Expedientes" class="table table-striped table-light table-hover table-bordered table-condensed " id="tablaDeExpedientes_table"
                data-search="false" 
                data-toggle="tablaDeExpedientes_table" 
                data-pagination="false" 
                data-toolbar="#tablaDeExpedientes_texto_div"
                data-page-size="5"
                data-page-list="[2,5,10]"
                data-undefined-text="Sin información"
                data-minimum-count-columns="0">
            <thead class="thead-dark">
                <tr>
                    <th v-if="!AccionesMostrar.consulta" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:10%;" class="text-center">Folio de Sentencia</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Consecutivo&nbsp;<i class="fa fa-sort" aria-hidden="true" style="cursor:pointer;"  v-on:click="ordenConsecutivo"></i></th>
                    <th v-if="AccionesMostrar.consulta" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:17%;" class="text-center">Juzgado</th>
                    <th v-if="AccionesMostrar.consulta" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Materia</th>
                    <th v-if="AccionesMostrar.consulta" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Tipo de documento</th>
                    <th v-if="!AccionesMostrar.consulta" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Folio documento padre</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:17%;" class="text-center">Naturaleza / Delitos</th>
                    <th v-if="AccionesMostrar.consulta" data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:17%;" class="text-center">Perspectiva de género</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Fecha de dictado&nbsp;<i class="fa fa-sort" style="cursor:pointer;" aria-hidden="true"  v-on:click="ordenFechaDictado"></i></th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:15%;" class="text-center">Tipo de Resolucion</th>
                    <th data-halign="center" data-align="center" data-sortable="true" data-switchable="false" data-visible="true" data-field="" style="width:12%;" class="text-center">Acciones</th>
                </tr>
            </thead>
            <tbody class="text-dark">
                 <template v-for="(expediente, indexExp) in Expedientes" > 
                    <tr v-for="(sentencia, index) in expediente.Sentencias" :key="'Expediente' + expediente.ExpedienteId + expediente.DocumentoPadreIdReferencia + index">
                        <td v-if="!AccionesMostrar.consulta" class="text-center align-middle" style="width:10%;">{{sentencia.SentenciaId > 0 ? sentencia.SentenciaId : ''}}</td>
                        <td v-if="index === 0 && AccionesMostrar.consulta" v-bind:rowspan = "expediente.Sentencias.length" class="text-center align-middle" style="width:15%;">{{expediente.Consecutivo}}</td>
                        <td v-else-if="index === 0" v-bind:rowspan = "expediente.Sentencias.length" class="text-center align-middle" style="width:15%;">{{expediente.Numero ? (expediente.Consecutivo + '-' + expediente.Numero) :  ( expediente.NumeroRomano? (expediente.Consecutivo + '-' + expediente.NumeroRomano) : ( expediente.CarpetaDeJuicio? (expediente.Consecutivo + '-' + expediente.CarpetaDeJuicio): expediente.Consecutivo)) }}</td>
                        <td v-if="AccionesMostrar.consulta" class="text-center align-middle" style="width:17%;">{{expediente.Juzgado.Nombre}}</td>
                        <td v-if="AccionesMostrar.consulta" class="text-center align-middle" style="width:12%;">{{expediente.Materia.Nombre}}</td>
                        <td v-if="AccionesMostrar.consulta" class="text-center align-middle" style="width:15%;">{{expediente.TipoDocumento.Nombre}}</td>
                        <td v-if="index === 0 && expediente.DocumentoPadreIdReferencia && !AccionesMostrar.consulta" v-bind:rowspan = "expediente.Sentencias.length" class="text-center align-middle" style="width:15%;">{{expediente.DocumentoPadreIdReferencia}}</td>
                        <td v-else-if="index === 0 && !AccionesMostrar.consulta" v-bind:rowspan = "expediente.Sentencias.length" class="text-center align-middle" style="width:17%;">No encontrado</td>
                        <td v-if="index === 0 && expediente.EsJuicio" v-bind:rowspan = "expediente.Sentencias.length" class="text-center align-middle" style="width:17%;">{{ expediente.Juicio ?  expediente.Juicio.Nombre : 'No encontrado' }}</td>
                        <td class="text-center" v-else-if="sentencia.Delitos && sentencia.Delitos.length > 0" style="width:17%;">
                            <ul v-if="sentencia.EsInformacionDesdeDBSICSEN && filtrarDelitosActivos(sentencia.Delitos).length > 0" id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="delito in filtrarDelitosActivos(sentencia.Delitos)" :key="delito.Delito.DelitoId">
                                    {{delito.Delito.Nombre}}
                                </li>
                            </ul>
                            <ul v-else-if="sentencia.EsInformacionDesdeDBSICSEN" id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li> No encontrados </li>
                            </ul>
                            <ul v-else id="listado_delitos" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="delito in sentencia.Delitos" :key="delito.Delito.DelitoId">
                                    {{delito.Delito.Nombre}}
                                </li>
                            </ul>
                        </td>                        
                        <td class="text-center align-middle" v-else-if="!expediente.EsJuicio" style="width:17%;">No encontrado</td> 
                        <td class="text-center" v-if="AccionesMostrar.consulta" style="width:17%;">
                            <ul v-if="sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero && sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero.length > 0" id="listado_perspectiva" class="mb-0 pl-4" style="text-align:left;">
                                <li v-for="clasificacion in sentencia.ClasificacionYCaracteristicasPerspectivaDeGenero" :key="clasificacion.SentenciaClasificacionPerspectivaDeGeneroId">
                                    {{clasificacion.TipoClasificacionPerspectivaDeGenero.Nombre}}
                                    <ul>
                                        <li v-for="(caracteristica, index) in clasificacion.SentenciaCaracteristicasPerspectivaDeGenero" v-bind:key="index + caracteristica.SentenciaClasificacionPerspectivaDeGeneroId + caracteristica.CaracteristicaPerspectivaDeGeneroId_065DBPJ">
                                            {{caracteristica.CaracteristicaPerspectivaDeGenero.Nombre}}
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                            <ul v-else id="listado_perspectiva" class="mb-0 pl-4" style="text-align:left;">
                                <li> No aplica </li>
                            </ul>
                        </td>
                        <td class="text-center align-middle" style="width:15%;">{{sentencia.FechaDeDictado ? obtenerFechaConFormato(sentencia.FechaDeDictado) : "No encontrado"}}</td>
                        <td class="text-center align-middle" style="width:15%;">{{sentencia.TipoResolucion ? sentencia.TipoResolucion.Nombre : 'No encontrado'}}</td>
                        <td class="text-center align-middle" style="width:12%;">
                            <i v-show="AccionesMostrar.alta && !sentencia.EsInformacionDesdeDBSICSEN" class="fas fa-file-upload fa-lg pl-1 pr-1 iconoHabilitado" @click="limpiarAccionesParaPadre(); informacionParaPadre.Accion.Alta = true; eventoValorParaElPadre(indexExp,index)"></i>
                            <i v-show="AccionesMostrar.cambios && sentencia.EsInformacionDesdeDBSICSEN" class="fas fa-edit fa-lg p-1 iconoHabilitado"  @click="limpiarAccionesParaPadre(); informacionParaPadre.Accion.Cambios = true; eventoValorParaElPadre(indexExp,index)"></i>
                            <i v-show="AccionesMostrar.visualizacion && sentencia.EsInformacionDesdeDBSICSEN" v-bind:class="[sentencia.ExisteArchivoFinal ? 'iconoHabilitado': 'iconoDeshabilitado','fas fa-eye fa-lg p-1']" @click="limpiarAccionesParaPadre(); informacionParaPadre.Accion.Visualizar = true; eventoValorParaElPadre(indexExp,index)" v-tooltip:top="!sentencia.ExisteArchivoFinal? textoVisorDehabilitado : ''"></i>
                            <i v-show="AccionesMostrar.baja && sentencia.EsInformacionDesdeDBSICSEN" class="fas fa-trash-alt fa-lg p-1 iconoHabilitado" @click="limpiarAccionesParaPadre(); informacionParaPadre.Accion.Baja = true; eventoValorParaElPadre(indexExp,index)"></i>
                            <i v-show="AccionesMostrar.agregar && sentencia.EsInformacionDesdeDBSICSEN" class="fa fa-plus-circle fa-lg p-1 iconoHabilitado" @click="limpiarAccionesParaPadre(); informacionParaPadre.Accion.Agregar = true; eventoValorParaElPadre(indexExp,index)"></i>                                                        
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
        </div>
        <hr />
    </div>
</template>
<script>
    import Vue from 'vue'
    import comun from "@/../static/js/comun"
    import enumeraciones from '@/../static/js/enumeraciones'
    import catalogos from '@/../static/js/catalogos'
    import moment from 'moment'
    import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

    export default {
        data() {
            return {
                indexExpediente: 0,
                enumeraciones,
                textoVisorDehabilitado:"El archivo no existe.",
                ordenaDesConsecutivo: true,
                ordenaDesFechaDictado: true,
                informacionParaPadre: {
                    Sentencia:Object,
                    Expediente:Object,
                    Accion:
                    {
                        Alta: false,
                        Baja:false,
                        Cambios: false,
                        Visualizar: false,
                        Agregar: false
                    }
                }
            }
        },
        directives: {
            tooltipF
        },
        props: {
            AccionesMostrar:{
                alta: false,
                baja: false,
                cambios: false,
                consulta: false,
                visualizacion: false,
                agregar: false
            },
            Expedientes: {},
            EsConsulta:true
        },
        mounted() { 
        
        },
        created() {
            this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);
            this.$store.dispatch('A_Comun_FechaInicial', this.fechaInicial);
            this.$store.dispatch('A_Comun_FechaFinal', this.fechaFinal);
            this.$store.dispatch('A_Comun_Fecha', this.fecha);
            this.$store.dispatch('A_SICSEN_Sentencias_FiltroBusqueda_FechaDeDictado', this.fechaDeDictado);
            this.$store.dispatch('A_SICSEN_Sentencias_FiltroBusqueda_FechaDeSentencia', this.fechaDeSentencia);
            this.$store.dispatch('A_SICSEN_Sentencias_FiltroBusqueda_FolioSentencia', this.folioSentencia);
        },
        methods: {
            /** 
             * Metodo encargado de filtrar los delitos a los activos
             */
            filtrarDelitosActivos:function(delitos)
            {
                var delitosActivos = delitos.filter(delito => {                  
                if(delito.Activo)
                    return delito;
                });
                return delitosActivos;
            },
            /**
             * Método encargado de ordenar por consecutivo el listado de expedientes dado.
             */
            ordenConsecutivo:function()
            {                 
                this.ordenaDesConsecutivo ?           
                    this.Expedientes.sort(function (a, b) {
                        if ((a.Consecutivo.substring(5,9) + "/" + a.Consecutivo.substring(0,4)) > (b.Consecutivo.substring(5,9) + "/" + b.Consecutivo.substring(0,4))) {
                            return 1;
                        }
                        if ((a.Consecutivo.substring(5,9) + "/" + a.Consecutivo.substring(0,4)) < (b.Consecutivo.substring(5,9) + "/" + b.Consecutivo.substring(0,4))) {
                            return -1;
                        }                        
                        return 0;
                        })            
                     :
                    this.Expedientes.sort(function (a, b) {
                        if ((a.Consecutivo.substring(5,9) + "/" + a.Consecutivo.substring(0,4)) < (b.Consecutivo.substring(5,9) + "/" + b.Consecutivo.substring(0,4))) {
                            return 1;
                        }
                        if ((a.Consecutivo.substring(5,9) + "/" + a.Consecutivo.substring(0,4)) > (b.Consecutivo.substring(5,9) + "/" + b.Consecutivo.substring(0,4))) {
                            return -1;
                        }                        
                        return 0;
                        });

                this.ordenaDesConsecutivo = this.ordenaDesConsecutivo ? false : true;          
            },
            /**
             * Método encargado de ordenar por fecha de dictado el listado de expedientes dado.
             */
            ordenFechaDictado:function()
            {
                if(this.ordenaDesFechaDictado) {
                    for(var i = 0; i < this.Expedientes.length; i++){
                        if(this.Expedientes[i].Sentencias.length > 1){
                            this.Expedientes[i].Sentencias.sort(function (a, b) {
                                if((a.FechaDeDictado != null || a.FechaDeDictado != undefined) && (b.FechaDeDictado != null || b.FechaDeDictado != undefined)){                                                               
                                    if (a.FechaDeDictado.substring(0,10) > b.FechaDeDictado.substring(0,10)) {
                                        return 1;
                                    }
                                    if (a.FechaDeDictado.substring(0,10) < b.FechaDeDictado.substring(0,10)) {
                                        return -1;
                                    }          
                                }else{
                                    if(a.FechaDeDictado != null || a.FechaDeDictado != undefined)
                                        return 1;
                                    else if(b.FechaDeDictado != null || b.FechaDeDictado != undefined)
                                        return -1;
                                }                                           
                                return 0; 
                            });
                        }
                    }
                    
                    this.Expedientes.sort(function (a, b) {
                        if((a.Sentencias[0].FechaDeDictado != null || a.Sentencias[0].FechaDeDictado != undefined) && (b.Sentencias[0].FechaDeDictado != null || b.Sentencias[0].FechaDeDictado != undefined)){
                            if (a.Sentencias[0].FechaDeDictado.substring(0,10) > b.Sentencias[0].FechaDeDictado.substring(0,10)) {
                                return 1;
                            }
                            if (a.Sentencias[0].FechaDeDictado.substring(0,10) < b.Sentencias[0].FechaDeDictado.substring(0,10)) {
                                return -1;
                            }       
                        }else{
                            if(a.Sentencias[0].FechaDeDictado != null || a.Sentencias[0].FechaDeDictado != undefined)
                                return 1;
                            else if(b.Sentencias[0].FechaDeDictado != null || b.Sentencias[0].FechaDeDictado != undefined)
                                return -1;
                        } 
                                       
                        return 0;
                    });
               }
                else {
                    for(var i = 0; i < this.Expedientes.length; i++){
                        if(this.Expedientes[i].Sentencias.length > 1){
                            this.Expedientes[i].Sentencias.sort(function (a, b) {
                                if((a.FechaDeDictado != null || a.FechaDeDictado != undefined) && (b.FechaDeDictado != null || b.FechaDeDictado != undefined)){
                                    if (a.FechaDeDictado.substring(0,10) < b.FechaDeDictado.substring(0,10)) {
                                        return 1;
                                    }
                                    if (a.FechaDeDictado.substring(0,10) > b.FechaDeDictado.substring(0,10)) {
                                        return -1;
                                    } 
                                }else{
                                    if(a.FechaDeDictado != null || a.FechaDeDictado != undefined)
                                        return -1;
                                    else if(b.FechaDeDictado != null || b.FechaDeDictado != undefined)
                                        return 1;
                                }                
                                return 0; 
                            });
                        }
                    }
                    
                    this.Expedientes.sort(function (a, b) {
                        if((a.Sentencias[0].FechaDeDictado != null || a.Sentencias[0].FechaDeDictado != undefined) && (b.Sentencias[0].FechaDeDictado != null || b.Sentencias[0].FechaDeDictado != undefined)){
                            if (a.Sentencias[0].FechaDeDictado.substring(0,10) < b.Sentencias[0].FechaDeDictado.substring(0,10)) {
                                return 1;
                            }
                            if (a.Sentencias[0].FechaDeDictado.substring(0,10) > b.Sentencias[0].FechaDeDictado.substring(0,10)) {
                                return -1;
                            }   
                        }else{
                            if(a.Sentencias[0].FechaDeDictado != null || a.Sentencias[0].FechaDeDictado != undefined)
                                return -1;
                            else if(b.Sentencias[0].FechaDeDictado != null || b.Sentencias[0].FechaDeDictado != undefined)
                                return 1;
                        }                                      
                        return 0;
                    });
                }
                this.ordenaDesFechaDictado = this.ordenaDesFechaDictado ? false : true;                                                            
            },
            /**
             * Método encargado de limpiar acciones que que transfieren al padre para realizar una acción.
             */
            limpiarAccionesParaPadre:function()
            {
                this.informacionParaPadre.Accion = {
                    Alta: false,
                    Baja:false,
                    Cambios: false,
                    Visualizar: false,
                    Agregar: false
                }
            },
            /**
             * Método encargado de enviar la información necesaria para trabajar a componente padre, se manda
             * un objeto sentencia y el objeto expediente, así como la acción a realizar.
             */
            eventoValorParaElPadre:function(indexDeElementoPadre, indexDeElemento)
            {
                if(indexDeElemento > -1) 
                {
                    this.informacionParaPadre.Sentencia = this.Expedientes[indexDeElementoPadre].Sentencias[indexDeElemento];
                    this.informacionParaPadre.Expediente = this.Expedientes[indexDeElementoPadre];
                    this.$emit("valorParaElPadreAccion", this.informacionParaPadre);
                } 
                else comun.mensajeDeAlerta("Ha sucedido un error con el elemento seleccionado.", null, null);
            },
            /**
             * Método encargado de obtener la fecha con un formato específico.
             */
            obtenerFechaConFormato:function(fecha)
            {
                return moment(fecha).format("DD-MM-YYYY");
            }
        }
    }
</script>

<style scoped>
    #encabezado-filtros .btn-sm {
    padding-left: 10px;
    padding-right: 10px;
    cursor: pointer;
    font-size: 16px;
    }

    .iconoDeshabilitado
    {
        cursor: not-allowed;
        opacity: 0.4;
    }
    .iconoHabilitado{
        cursor: pointer;
    }
    .altoDeTablaFijo
    {
        max-height:80vh;
    }
    .altoDeTablaFijo thead th {
        position: sticky;
        top: 0;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICSEN/Comun/TablaDeResultados.vue